'use strict';
var collection = require('../internals/collection');
var collectionStrong = require('../internals/collection-strong');

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = collection('Map', function (get) {
  return function Map() { return get(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong, true);



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/modules/es.map.js
// module id = Npbf
// module chunks = 0